import { ActionButton } from '@cycle-app/ui';
import styled, { css } from 'styled-components';

export const ActionButtonStyled = styled(ActionButton)`
  white-space: nowrap;
  ${p => p.counter && css`
    border: 1px solid ${p.theme.colors.border.primary}
  `}
`;
